import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import ButtonComponent from '../../../Button';
import Modal from '../../index';

import { Container } from './styles';
import FillCPF from '../FillCPF';

interface Props {
  handlerClose: () => void;
  verification: string;
}

const MessageOfAgendar: React.FC<Props> = ({ handlerClose, verification }) => {
  const configs = useSelector((state: ApplicationState) => state.config);
  const [currentPage, setCurrentPage] = useState(false);
  const [title, setTitle] = useState('Agendar uma ligação');
  const validateSaturdayTime = useMemo(
    () =>
      configs.startSaturdayAttendance &&
      configs.endSaturdayAttendance &&
      configs.startSaturdayAttendance !== '00:00' &&
      configs.endSaturdayAttendance !== '00:00',
    [configs]
  );

  const handleChangeTitle = () => {
    setTitle('');
  };

  const nextStep = () => {
    setCurrentPage(!currentPage);
  };

  return (
    <Modal
      title={title}
      handlerClose={handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
    >
      {!currentPage ? (
        <Container>
          <span className='title'>
            No momento estamos fora do nosso horário de atendimento. Tente
            novamente em um dos horários abaixo ou agende uma ligação.
          </span>
          <div className='attendanceDiv'>
            <span className={'fix'}>HORÁRIO DE FUNCIONAMENTO</span>
            <span className={'attendance'}>
              Seg a Sex de {configs.startBusinessDayAttendance}h às{' '}
              {configs.endBusinessDayAttendance}h
            </span>
            {validateSaturdayTime && (
              <span className={'attendance'}>
                Sábado de {configs.startSaturdayAttendance}h às{' '}
                {configs.endSaturdayAttendance}h
              </span>
            )}
          </div>
          <div className='btns_receivecall'>
            <ButtonComponent
              height={60}
              onClick={nextStep}
              children={<p>AGENDAR LIGAÇÃO</p>}
              color={'primary'}
              fontSize={'16'}
              borderRadios={'16'}
            />
          </div>
        </Container>
      ) : (
        <FillCPF
          title={'Preencha seu CPF abaixo para que possamos saber quem você é:'}
          subtitle={'Seu CPF'}
          handlerClose={handlerClose}
          changeTitle={handleChangeTitle}
          textbtn={'AGENDAR'}
          text2btn={''}
          type={''}
          verification={verification}
          details={{
            title: 'Agendamento concluído!',
            subtitle:
              'No horário escolhido, aguarde que um de nossos operadores entrará em contato.',
            detail: 'Detalhes do agendamento:',
            datehour: '05/11/2020 às 09:15',
          }}
        />
      )}
    </Modal>
  );
};

export default MessageOfAgendar;
